export const FUNDRAISING_PHONE_NUMBER = {
  COPY: '855-631-6850',
  TEL_LINK: 'tel:+18556316850'
};

export const SPONSORSHIP_PHONE_NUMBER = {
  COPY: '844-586-2361',
  TEL_LINK: 'tel:+8445862361'
};

export const SUPPORT_PHONE_NUMBER = {
  COPY: '855‑563‑7465',
  TEL_LINK: 'tel:+18555637465'
};

export const SUPPORT_MAILTO_ADDRESS = 'mailto:mobilehelp@customink.com';
export const FEEDBACK_MAILTO_ADDRESS = 'mailto:newlab@customink.com';
